module.exports = __webpack_public_path__ + "media/application/images/value-created-bg-129bd919b891188e6272426501f42d40.png";